import gql from 'graphql-tag';
import { Fragments } from '@shared/api/fragments';

export const getCurrentUser = gql`
  query GetCurrentUserQuery($id: Int!) {
    user: getUser(id: $id) {
      ...Profile
    }
  }

  ${Fragments.user.profile}
`;

export const legacyGetNotificationSettings = gql`
  query LegacyGetNotificationSettingsQuery {
    legacyGetNotificationSettings {
      notificationsPreference
      snoozeUntil
    }
  }
`;

export const personalDetails = gql`
  query PersonalDetailsQuery($id: Int!) {
    user: getUser(id: $id) {
      ...PersonalDetailsUser
    }
  }

  ${Fragments.user.personalDetails}
`;

export const userGlobalPermissions = gql`
  query UserGlobalPermissionsQuery {
    caslAbility: getAppAbility
  }
`;

export const listUserGroups = gql`
  query ListUserGroupsQuery($input: ListUserGroups!) {
    listUserGroups(input: $input) {
      hasMore
      userGroups {
        ...UserGroup
      }
    }
  }

  ${Fragments.user.userGroup}
`;

export const getUserGroup = gql`
  query GetUserGroupQuery($id: UUID!) {
    getUserGroup(id: $id) {
      ...UserGroup
    }
  }

  ${Fragments.user.userGroup}
`;

export const listUserGroupUserAssociations = gql`
  query ListUserGroupUserAssociationsQuery($input: ListUserGroupUserAssociations!) {
    listUserGroupUserAssociations(input: $input) {
      hasMore
      userGroupUserAssociations {
        ...UserGroupUserAssociation
      }
    }
  }

  ${Fragments.user.userGroupUserAssociation}
`;

export const listUsers = gql`
  query ListUsersQuery($input: ListUsers!, $customCacheKey: String!) {
    listUsers(input: $input) @connection(key: $customCacheKey) {
      users {
        ...CollectionViewUser
      }
      total
      hasMore
    }
  }

  ${Fragments.user.collectionViewUser}
`;

export const listDirectoryUsers = gql`
  query ListDirectoryUsersQuery($input: ListUsers!, $customCacheKey: String!) {
    listUsers(input: $input) @connection(key: $customCacheKey) {
      users {
        ...DirectoryUser
      }
      total
      hasMore
    }
  }

  ${Fragments.user.directoryUser}
`;
